import React, { FC } from 'react';

import { CloseIcon } from '@evinced-private/ui-common';

import { AnnouncementBanner } from 'src/apps/mobile-sdk/components/announcement-banner/AnnouncementBanner';
import { MobileSdkPlatformPage } from 'src/apps/mobile-sdk/pages/all-tesks/MobileSdkPlatformPage';
import { useMobileSdkBannerStore } from 'src/apps/mobile-sdk/stores/mobileSdkBannerStore';
import { ClarificationBanner } from 'src/common/components/clarification-banner/ClarificationBanner';
import { ProductType } from 'src/common/interfaces/Tenant';
import { DashboardContainer } from 'src/common/pages/dashboards-container/DashboardContainer';

import './DashboardContainerMobileSDK.scss';

export const DashboardContainerMobileSDK: FC = () => {
	const { visible: isBannerVisible, setVisible } = useMobileSdkBannerStore();

	return (
		<div className="dashboard-container-mobile-sdk">
			{isBannerVisible && (
				<div className="clarification-banner-wrapper">
					<ClarificationBanner
						hide={() => setVisible(false)}
						dismissIcon={CloseIcon}
						showToggle={false}
					>
						<AnnouncementBanner />
					</ClarificationBanner>
				</div>
			)}
			<DashboardContainer product={ProductType.MOBILE_SDK}>
				<MobileSdkPlatformPage />
			</DashboardContainer>
		</div>
	);
};
